module.exports = __webpack_public_path__ + "assets/img/banner.06a1668a.png";